import { render, staticRenderFns } from "./SuperPassPasses.vue?vue&type=template&id=4b443768&"
import script from "./SuperPassPasses.vue?vue&type=script&lang=js&"
export * from "./SuperPassPasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports